module.exports = __webpack_public_path__ + "static/media/certas-energy-logo-charcoal.9ad80e8e.svg";